import Downloads from './Downloads';

export default function Reports() {
    return (
        <Downloads
            titleLead="Our"
            titleBold="Reports"
            intro="Annual reviews, impact reports and monitoring findings documenting how justice is delivered — and where it still falls short."
            basePath="/resources/reports"
            label="All Reports"
            topLabel="Top Report"
            recentLabel="Recent Reports"
        />
    );
}
